<template>
  <v-tooltip v-if="tooltip" location="top" class="rounded-tooltip">
    <template v-slot:activator="{props}">
      <span class="waitlist-chip" :class="iconOnly ? 'icon-only' : ''" v-bind="{ ...props, ...$attrs }">
        <v-icon :size="16">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
            <path
              d="M2.5 3.5H5.5V2.5C5.5 2.08333 5.35417 1.72917 5.0625 1.4375C4.77083 1.14583 4.41667 1 4 1C3.58333 1 3.22917 1.14583 2.9375 1.4375C2.64583 1.72917 2.5 2.08333 2.5 2.5V3.5ZM7 11C6.30833 11 5.71875 10.7563 5.23125 10.2688C4.74375 9.78125 4.5 9.19167 4.5 8.5C4.5 7.80833 4.74375 7.21875 5.23125 6.73125C5.71875 6.24375 6.30833 6 7 6C7.69167 6 8.28125 6.24375 8.76875 6.73125C9.25625 7.21875 9.5 7.80833 9.5 8.5C9.5 9.19167 9.25625 9.78125 8.76875 10.2688C8.28125 10.7563 7.69167 11 7 11ZM7.825 9.675L8.175 9.325L7.25 8.4V7H6.75V8.6L7.825 9.675ZM4.125 10.5H1C0.725 10.5 0.489583 10.4021 0.29375 10.2063C0.0979167 10.0104 0 9.775 0 9.5V4.5C0 4.225 0.0979167 3.98958 0.29375 3.79375C0.489583 3.59792 0.725 3.5 1 3.5H1.5V2.5C1.5 1.80833 1.74375 1.21875 2.23125 0.73125C2.71875 0.24375 3.30833 0 4 0C4.69167 0 5.28125 0.24375 5.76875 0.73125C6.25625 1.21875 6.5 1.80833 6.5 2.5V3.5H7C7.275 3.5 7.51042 3.59792 7.70625 3.79375C7.90208 3.98958 8 4.225 8 4.5V5.15C7.83333 5.09167 7.66667 5.05208 7.5 5.03125C7.33333 5.01042 7.16667 5 7 5C6.025 5 5.19792 5.33958 4.51875 6.01875C3.83958 6.69792 3.5 7.525 3.5 8.5C3.5 8.85833 3.55625 9.20625 3.66875 9.54375C3.78125 9.88125 3.93333 10.2 4.125 10.5Z"
              fill="white" />
          </svg>
        </v-icon>
        <span v-if="!iconOnly" class="waitlist-label">{{ label }}</span>
      </span>
    </template>
    <span class="tooltip-text">{{ tooltip }}</span>
  </v-tooltip>

  <span v-else class="waitlist-chip" :class="iconOnly ? 'icon-only' : ''">
    <v-icon :size="16">
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
        <path
          d="M2.5 3.5H5.5V2.5C5.5 2.08333 5.35417 1.72917 5.0625 1.4375C4.77083 1.14583 4.41667 1 4 1C3.58333 1 3.22917 1.14583 2.9375 1.4375C2.64583 1.72917 2.5 2.08333 2.5 2.5V3.5ZM7 11C6.30833 11 5.71875 10.7563 5.23125 10.2688C4.74375 9.78125 4.5 9.19167 4.5 8.5C4.5 7.80833 4.74375 7.21875 5.23125 6.73125C5.71875 6.24375 6.30833 6 7 6C7.69167 6 8.28125 6.24375 8.76875 6.73125C9.25625 7.21875 9.5 7.80833 9.5 8.5C9.5 9.19167 9.25625 9.78125 8.76875 10.2688C8.28125 10.7563 7.69167 11 7 11ZM7.825 9.675L8.175 9.325L7.25 8.4V7H6.75V8.6L7.825 9.675ZM4.125 10.5H1C0.725 10.5 0.489583 10.4021 0.29375 10.2063C0.0979167 10.0104 0 9.775 0 9.5V4.5C0 4.225 0.0979167 3.98958 0.29375 3.79375C0.489583 3.59792 0.725 3.5 1 3.5H1.5V2.5C1.5 1.80833 1.74375 1.21875 2.23125 0.73125C2.71875 0.24375 3.30833 0 4 0C4.69167 0 5.28125 0.24375 5.76875 0.73125C6.25625 1.21875 6.5 1.80833 6.5 2.5V3.5H7C7.275 3.5 7.51042 3.59792 7.70625 3.79375C7.90208 3.98958 8 4.225 8 4.5V5.15C7.83333 5.09167 7.66667 5.05208 7.5 5.03125C7.33333 5.01042 7.16667 5 7 5C6.025 5 5.19792 5.33958 4.51875 6.01875C3.83958 6.69792 3.5 7.525 3.5 8.5C3.5 8.85833 3.55625 9.20625 3.66875 9.54375C3.78125 9.88125 3.93333 10.2 4.125 10.5Z"
          fill="white" />
      </svg>
    </v-icon>
    <span v-if="!iconOnly" class="waitlist-label">{{ label }}</span>
  </span>
</template>

<script>
export default {
  props: {
    tooltip: {
      type: String,
      default: "",
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      return this.variant === "full" ? this.$t("waitlist.badge_full") : this.$t("waitlist.badge");
    },
    iconSize() {
      return this.small ? 12 : 16;
    },
    badgeClass() {
      return ["waitlist-badge", this.iconOnly ? "waitlist-badge--icon" : "", this.small ? "waitlist-badge--small" : ""];
    },
  },
};
</script>
